import { render, staticRenderFns } from "./msnav.vue?vue&type=template&id=3d982cb9"
import script from "./msnav.vue?vue&type=script&lang=js"
export * from "./msnav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports